<template>
    <div class="content">
      <!-- 背景图和文字 -->
      <div class="background-section">
        <div class="text-overlay">
          <h2>För att vi ska kunna gå igenom denna speciella tid</h2>
          <p>
            Vi desinficerar hela kliniken med ultraviolet strålning två
            gånger dagligen och torkar av alla handtag med
            desinfektionsmedel.
          </p>
          <p>
            Vi gör vårt yttersta för att kunna bibehålla en säker vårdmiljö
            för alla.
          </p>
          <el-button type="primary" @click="toLink">BOKA TID</el-button>
        </div>
      </div>
  
      <!-- 医生介绍 -->
      <div class="doctor-cards">
        <div class="doctor-card" v-for="(doctor, index) in doctors" :key="index">
          <el-image :src="doctor.imgUrl" class="doctor-img"></el-image>
          <p v-for="(line, i) in doctor.description" :key="i">{{ line }}</p>
          <el-button @click="goToExpert(doctor.name)">Läs mer</el-button>
        </div>
      </div>
  
      <!-- 诊所介绍 -->
      <div class="clinic-section">
        <div class="clinic-content">
          <img src="@/assets/home/klinikInfo.jpg" alt="Clinic" class="clinic-img" />
          <div class="clinic-text">
            <h3><span>OM</span> KINESISK KLINIK</h3>
            <p>
              Vi sprider traditionell kinesisk medicin här och vi hoppas vi kan hjälpa fler människor av traditionell kinesisk medicin ...
            </p>
            <button class="clinic-btn">MORE INFO</button>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
export default {
    name: "HomeMain",
    data() {
      return {
        doctors: [
          {
            name: "Mo Dong",
            imgUrl: require("@/assets/home/person1.jpg"),
            description: [
              "Mo Dong Har arbetat som föreläsare i kinesisk",
              "medicin på bland annat Bethune Higher Medical College,",
              "Shijiazhuang City, Hebei provinsen under 2010 till 2022.",
              "På Hebei College of Traditional Chinese...",
            ],
          },
          {
            name: "Ying Zhou",
            imgUrl: require("@/assets/home/person2.jpg"),
            description: [
              "Zhou Ying har sedan 2004 ett praktiserande certifikat",
              "för medicinsk verksamhet i Kina.",
              "Mellan åren 1999-2003 studerade hon kinesisk",
              "och västerländsk medicin vid Hebei medicinska universitet.",
            ],
          },
          {
            name: "Professor Wanchun Guo",
            imgUrl: require("@/assets/home/person3.jpg"),
            description: [
              "Professor Wanchun Guo är akupunktör med en",
              "mastersexamen, bakgrund och erfarenhet som M.Sc.",
              "General Practitioner - Traditional Chinese Medicine",
              "specializing in Acupuncture...",
            ],
          },
        ],
      };
    },
    methods: {
      toLink() {
        window.open('https://yghealthab.simplybook.it/v2/', '_blank');
      },
      goToExpert(name) {
        const id = name
          .toLowerCase()
          .replace(/\s+/g, '-') // 替换空格为连字符
          .replace(/[^a-z0-9-]/g, ''); // 移除特殊字符
        this.$router.push({ name: 'PeosonInfo', hash: id });
      },
    },
};
</script>
  
<style scoped>
/* 主要内容容器 */
.content {
  width: 100%;
  min-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 背景图片 */
.background-section {
  width: 100%;
  height: 40vh; /* 让背景部分适应屏幕 */
  background-image: url("@/assets/home/banner.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

/* 文字叠加层 */
.text-overlay {
  background: rgba(0, 0, 0, 0.5);
  padding: 20px;
  color: white;
  border-radius: 10px;
  max-width: 80%;
}

/* 医生介绍 */
.doctor-cards {
  display: flex;
  justify-content: center; /* 居中对齐 */
  width: 100%;
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
}

/* 医生卡片 */
.doctor-card {
  flex: 1;
  text-align: center;
  background: white;
  flex: 1 1 calc(33.33% - 20px); /* 让每个卡片占 1/3 宽度，减去间距 */
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.doctor-img {
  width: 100%;
  max-width: 250px;
  height: auto;
  border-radius: 10px;
}
.el-image__inner {
  height: 500px;
}

/* 诊所介绍 */
.clinic-section {
  background: url("@/assets/bg.png") no-repeat center;
  background-size: cover;
  padding: 60px 10%;
  display: flex;
  justify-content: center;
}

.clinic-content {
  display: flex;
  align-items: center;
  min-width: 1200px;
  width: 100%;
}

.clinic-img {
  width: 320px;
  height: auto;
  border-radius: 10px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.2);
}

.clinic-text {
  margin-left: 40px;
  max-width: 500px;
}

.clinic-text h3 {
  font-size: 24px;
  font-weight: bold;
}

.clinic-text h3 span {
  color: #2e7d32; /* 绿色样式 */
  border-left: 5px solid #2e7d32;
  padding-left: 10px;
}

.clinic-text p {
  margin-top: 10px;
  font-size: 16px;
  color: #333;
}

/* 按钮样式 */
.clinic-btn {
  margin-top: 15px;
  padding: 10px 20px;
  background-color: transparent;
  border: 2px solid #2e7d32;
  color: #2e7d32;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.clinic-btn:hover {
  background-color: #2e7d32;
  color: #fff;
}
</style>
